<!--
 * @developerName: 邓科峰
 * @Function name:
 * @Date: 2025-12-05 10:12:30
 * @param:
 * @LastEditor:
 * @LastData:
 * @Describe:
-->
<!-- src/components/person.vue -->
<template>
  <div class="person-center">
    <van-nav-bar title="个人中心" left-text="返回"  @click-left="$router.back()" />
    <!-- 用户信息区域 -->
    <div class="user-info" v-if="userInfo">
      <van-cell-group>
        <van-cell>
          <div class="user-avatar">
            <van-icon name="user-o" size="40" />
          </div>
          <div class="user-details">
            <div class="user-name">{{ userInfo.name || '用户名' }}</div>
            <div class="user-phone">用户登录手机号为用户名信息</div>
          </div>
        </van-cell>
      </van-cell-group>
    </div>

    <!-- 未登录状态 -->
    <div class="login-prompt" v-else>
      <van-empty description="请先登录">
        <van-button round type="primary" @click="goToLogin">立即登录</van-button>
      </van-empty>
    </div>

    <!-- 功能菜单 -->
    <div class="menu-list" v-if="userInfo">
      <van-cell-group>
        <van-cell title="我的订单" is-link icon="orders-o" @click="goToOrders" />
        <van-cell title="发布的订单" is-link icon="todo-list-o" @click="goToPublished" />
        <!-- <van-cell title="账户设置" is-link icon="setting-o" @click="goToSettings" /> -->
      </van-cell-group>
    </div>

    <!-- 登出按钮 -->
    <div class="logout-section" v-if="userInfo">
      <van-button class="logout-btn" type="danger" block @click="handleLogout">
        退出登录
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonCenter',
  data () {
    return {
      userInfo: null
    }
  },
  mounted () {
    this.checkLoginStatus()
  },
  methods: {
    // 检查登录状态
    checkLoginStatus () {
      const user = localStorage.getItem('userInfo')
      if (user) {
        try {
          this.userInfo = JSON.parse(user)
        } catch (error) {
          console.error('用户信息解析失败:', error)
        }
      }
    },

    // 跳转到订单页面
    goToOrders () {
      this.$router.push('/my-orders')
    },

    // 跳转到发布的订单页面
    goToPublished () {
      this.$router.push('/create-order')
    },

    // 跳转到设置页面
    goToSettings () {
      this.$router.push('/settings')
    },

    // 跳转到登录页面
    goToLogin () {
      this.$router.push('/login')
    },

    // 退出登录
    handleLogout () {
      this.$dialog.confirm({
        title: '提示',
        message: '确定要退出登录吗？'
      }).then(() => {
        // 清除本地存储的用户信息
        localStorage.removeItem('userInfo')
        this.userInfo = null
        this.$toast.success('退出成功')
        this.goToLogin()
      }).catch(() => {
        // 取消操作
      })
    }
  }
}
</script>

<style scoped>
.person-center {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.user-info {
  padding: 15px;
}

.user-avatar {
  display: inline-block;
  margin-right: 15px;
}

.user-details {
  display: inline-block;
  vertical-align: top;
}

.user-name {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 5px;
}

.user-phone {
  color: #999;
  font-size: 14px;
}

.menu-list {
  margin: 15px 0;
}

.logout-section {
  padding: 0 15px;
  margin-top: 30px;
}

.logout-btn {
  border-radius: 8px;
}

.login-prompt {
  padding-top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/person.vue